"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeckCsvHeader = void 0;
var DeckCsvHeader;
(function (DeckCsvHeader) {
    DeckCsvHeader["Back"] = "Back";
    DeckCsvHeader["Front"] = "Front";
    DeckCsvHeader["TypeName"] = "TypeName";
})(DeckCsvHeader = exports.DeckCsvHeader || (exports.DeckCsvHeader = {}));
